import React, { useState, useEffect } from 'react';
import { db } from '../firebase'; 
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import './Guestbook.css';

const Guestbook = () => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const q = query(collection(db, 'messages'), orderBy('createdAt', 'desc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setMessages(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="guestbook-container">
      {/* FIXED: Added closing tag for guestbook-header here */}
      <div className="guestbook-header">
        <span className="header-icon">💝</span>
        <h1>Wish Wall</h1>
        <p>A collection of love and beautiful wishes</p>
      </div> 

      <div className="messages-grid">
        {messages.map((msg, index) => (
          <div 
            key={msg.id} 
            className="message-card" 
            style={{ animationDelay: `${index * 0.1}s` }} // Staggered entrance
          >
            <div className="card-decoration">✨</div>
            <p className="message-text">“{msg.text}”</p>
            <div className="card-footer">
              <h4 className="message-author">{msg.name}</h4>
            </div>
          </div>
        ))}
        
        {messages.length === 0 && (
          <div className="empty-state-container">
            <p className="empty-state">Waiting for the first wish to arrive...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Guestbook;